import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { StubsService } from '../Services/stubs.service';

import { Service } from '../models/service.model';
import { Stub } from '../models/stub.model';

@Component({
  selector: 'app-stubs-overview',
  templateUrl: './stubs-overview.component.html',
  styleUrls: ['./stubs-overview.component.css']
})
export class StubsOverviewComponent implements OnInit {

  public isOpen: boolean = false;

  private stubs: Stub[];

  /** holds lazy loaded item that displayed to the user */
  private frontEndStubs: Stub[];

  /** holds the search results */
  private searchResultsStubs: Stub[];

  private searchItem: string;
  private serviceName: string;
  public statusCodes: any = [
    {
      code: '200',
      name: 'OK'
    },
    {
      code: '201',
      name: 'CREATED'
    },
    {
      code: '202',
      name: 'ACCEPTED'
    },
    {
      code: '204',
      name: 'NO CONTENT'
    },
    {
      code: '300',
      name: 'MULTIPLE CHOICES'
    },
    {
      code: '302',
      name: 'URL REDIRECTION'
    },
    {
      code: '400',
      name: 'BAD REQUEST'
    },
    {
      code: '401',
      name: 'UNAUTHORIZED'
    },
    {
      code: '403',
      name: 'FORBIDDEN'
    },
    {
      code: '423',
      name: 'LOCKED'
    },
    {
      code: '500',
      name: 'INTERNAL SERVER ERROR'
    },
    {
      code: '502',
      name: 'BAD GATEWAY'
    },
    {
      code: '404',
      name: 'NOT FOUND'
    },
    {
      code: '405',
      name: 'Method Not Allowed'
    },
    {
      code: '406',
      name: 'Not Acceptable'
    },
    {
      code: '409',
      name: 'Conflict'
    },
    {
      code: '413',
      name: 'Request Entity Too Large'
    },
    {
      code: '414',
      name: 'Request-URI Too Long'
    },
    {
      code: '415',
      name: 'Unsupported Media Type'
    },
    {
      code: '422',
      name: 'Unprocessable Entity (WebDAV)'
    },
    {
      code: '429',
      name: 'Too Many Requests'
    },
    {
      code: '503',
      name: 'Service Unavailable'
    },
    {
      code: '504',
      name: 'Gateway Timeout'
    }
  ];
  // private identifier:string;
  // private page:number = 0;
  // private pageSize:number=1;

  private lastScrollValue: number = 0;
  constructor(private _stubsService: StubsService, private _route: ActivatedRoute,
    private _router: Router) { }

  ngOnInit(): void {
    /** initial values for properties */
    this.searchItem = '';
    this.frontEndStubs = [];
    this.searchResultsStubs = [];
    this.serviceName = this._route.snapshot.params['id'];
    // this.identifier=this._route.snapshot.params['identifier'];
    this.LoadStubsData();
  }
  LoadStubsData(): void {
    this._stubsService.getStubsData(this.serviceName, true)
      .subscribe(stubsData => {
        this.stubs = [];
        this.searchItem = '';
        this.frontEndStubs = [];
        this.searchResultsStubs = [];
        this.stubs = stubsData;
        /** retrieve first 10 item to be displayed */
        this.loadMore(20);
      },
        error => console.log(error));
  }
  onBack(): void {
    this._router.navigate(['']);
  }

  deleteStub(id: string): void {
    this._stubsService.deleteStubData(this.serviceName, id).subscribe(resp => {
      this.LoadStubsData();
    });
  }

  editStub(id: string): void {
    this._router.navigate(['/stubsdataedit', this.serviceName, id]);
  }

  getCodeName(code) {
    let codeObj = this.statusCodes.filter(item => item.code == code)
    return codeObj ? codeObj[0].name : '';
  }

  /**
   * lazy loading ten items from those retrieved from the service 
   */
  loadMore(numberOfStubs: number) {
    if (this.searchResultsStubs.length > 0) {
      this.frontEndStubs = this.frontEndStubs.concat(this.searchResultsStubs.slice(this.frontEndStubs.length, this.frontEndStubs.length + numberOfStubs));
    } else {
      if (this.stubs) {
        this.frontEndStubs = this.frontEndStubs.concat(this.stubs.slice(this.frontEndStubs.length, this.frontEndStubs.length + numberOfStubs));
      }
    }
  }

  /**
   * Determine the scroll of page to load more items 
   */
  onScroll(event) {

    if (window.scrollY > (this.lastScrollValue + 200)) {

      this.lastScrollValue = window.scrollY;

      this.loadMore(5);
    }
  }

  /**
   * filtering displayed items based on the filter textbox
   */
  filterResults() {
    //reset the results
    this.searchResultsStubs = [];
    this.frontEndStubs = [];

    this.lastScrollValue = 0;

    if (this.stubs && this.frontEndStubs && this.searchItem) {
      /** fill the result array with matched keys */
      this.searchResultsStubs = this.stubs.filter(item => item.stubName.toLowerCase().indexOf(this.searchItem.toLowerCase()) > -1);
    }
    /** load first ten items of matched result into the view */
    this.loadMore(20);
  }
}



// WEBPACK FOOTER //
// ./src/app/stubs-overview/stubs-overview.component.ts